import { uint8ArrayToBlob } from "./uint8array-to-blob";
import { blobToFile } from "./blob-to-file";

/**
 * coverts a Uint8Array to a File
 *
 * A File is a Blob with additional properties attached to the object.
 */
export const uint8ArrayToFile = (buffer: Uint8Array, fileName: string): File => {
  const blob = uint8ArrayToBlob(buffer);

  return blobToFile(blob, fileName);
};
